/**
 * @generated SignedSource<<df7520f416990b7ea354bd180ebbf5d8>>
 * @relayHash 2e297c1c13030e1076e9824fd5d2a980
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c92f1be3270abe12ed67e74d49a037adb7fd525c50a49b7e919a756b0338f965

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBoardEmbedQuery } from './src_jiraBoardEmbedQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBoardEmbedQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "c92f1be3270abe12ed67e74d49a037adb7fd525c50a49b7e919a756b0338f965",
    "metadata": {},
    "name": "src_jiraBoardEmbedQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
